interface HighlightMatchProps {
  text: string
  query: string
  highlightClassName?: string
}

export default function HighlightMatch({
  text,
  query,
  highlightClassName = 'bg-yellow-200',
}: HighlightMatchProps) {
  if (!query.trim()) {
    return <>{text}</>
  }

  const regex = new RegExp(`(${escapeRegExp(query)})`, 'gi')
  const parts = text.split(regex)

  return (
    <>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <span key={index} className={highlightClassName}>
            {part}
          </span>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </>
  )
}

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
